import type { MaintenanceResult } from '@/shared/types/phase-contracts';
import type { TDBattleResult } from '../types/internal';
import { WAVE_CONFIGS } from '../data/wave-configs';

export function mapTDBattleResult(tdResult: TDBattleResult): MaintenanceResult {
  return {
    outcome: tdResult.outcome,
    towersBuilt: tdResult.towersBuilt,
    enemiesKilled: tdResult.enemiesKilled,
    wavesCompleted: tdResult.wavesCompleted,
    totalWaves: WAVE_CONFIGS.length,
    baseHealthRemaining: tdResult.baseHealthRemaining,
    moneyEarned: tdResult.moneyEarned,
  };
}
